export const SMALLEST_UNSAFE_INTEGER = 0x20000000000000;
export const LARGEST_SAFE_INTEGER = SMALLEST_UNSAFE_INTEGER - 1;
export const UINT32_MAX = -1 >>> 0;
export const UINT32_SIZE = UINT32_MAX + 1;
export const INT32_SIZE = UINT32_SIZE / 2;
export const INT32_MAX = INT32_SIZE - 1;
export const UINT21_SIZE = 1 << 21;
export const UINT21_MAX = UINT21_SIZE - 1;
